import React  from 'react'
import CartHeaderCount from '../../../components/Cart/CartHeaderCount'
import { ErrorBoundary } from '../../../components/Error/ErrorBoundary'
import { HeaderWishlist } from '../../../components/Header/HeaderWishlist'

import { HeaderBarMovile } from '../HeaderBarMovile'

export function HeaderMobile(props) {
    const {
        isLoged,
        profile,
        totalItems,
        page = null,
    } = props

    const hostName = window.location.origin;

    return (
        <>
            <header className={page}>
                <div className="headerMobile">

                    <ErrorBoundary>
                        <div className="bxarrowLeft" >
                            <a href="/" className="logoClaroshop" aria-label="logoSears"></a>
                        </div>
                    </ErrorBoundary>

                    {/*<a href="/buscador" className="searchIcon" aria-label="Icono Buscador"></a>"*/}
                    <ErrorBoundary>
                        <HeaderWishlist
                            ruta={isLoged ? '/mi-cuenta/listadeseos/' : `/login?redirect=${hostName}/mi-cuenta/listadeseos/`}
                        />
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <CartHeaderCount
                            ruta={isLoged ? '/carrito/detalle' : `/login?redirect=${hostName}/carrito/detalle`}
                            cantidad={isLoged ? totalItems : 0}
                        />
                    </ErrorBoundary>

                    <div className="menuPrincipal">
                        <HeaderBarMovile isLoged={isLoged} profile={profile} />
                    </div>

                </div>
            </header>
        </>
    )
}